import React from 'react';
import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';

/**
 * Cabecera de tabla ordenable.
 *   <SortableHeader label="Empresa" sortKey="razon_social"
 *     currentKey={sortKey} dir={sortDir} onToggle={toggle} />
 */
export const SortableHeader = ({
  label,
  sortKey,
  currentKey,
  dir,
  onToggle,
  className = '',
  align = 'left',
}) => {
  const active = currentKey === sortKey;
  const Icon = active ? (dir === 'asc' ? ArrowUp : ArrowDown) : ChevronsUpDown;
  const justify = align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : 'justify-start';
  return (
    <th
      onClick={() => onToggle(sortKey)}
      className={`cursor-pointer select-none hover:bg-ink-50 px-3 py-2 text-xs font-semibold text-ink-500 uppercase tracking-wider ${className}`}
      data-testid={`th-sort-${sortKey}`}
    >
      <span className={`inline-flex items-center gap-1 ${justify}`}>
        {label}
        <Icon className={`w-3 h-3 ${active ? 'text-brand-600' : 'text-ink-300'}`} />
      </span>
    </th>
  );
};

export default SortableHeader;
